'use client';

import { ButtonMini } from '@/components/UI/moving-border-mini';
import Image from 'next/image';
import { useState, useRef, useEffect } from 'react';
import './buttonInhance.css';
import { Link as ScrollLink } from 'react-scroll';
import NextLink from 'next/link'; // Import Next.js Link
import { FaHamburger, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const isSidebarOpen = useRef(false); // Ref for sidebar state
  const sidebarRef = useRef(null); // Ref for sidebar DOM node
  const navItems = ['About', 'Projects', 'Resume', 'LinkedIn'];

  useEffect(() => {
    const handleScroll = () => {
      const heroSectionHeight =
        document.querySelector('.home')?.offsetHeight || 0;
      setIsScrolled(window.scrollY > heroSectionHeight - 80);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openSidebar = () => {
    isSidebarOpen.current = true;
    sidebarRef.current?.classList.remove('-translate-x-full');
    sidebarRef.current?.classList.add('translate-x-0');
  };

  const closeSidebar = () => {
    isSidebarOpen.current = false;
    sidebarRef.current?.classList.remove('translate-x-0');
    sidebarRef.current?.classList.add('-translate-x-full');
  };

  const externalLinks = {
    Resume:
      'https://drive.google.com/file/d/1uki9PZjAGc-aZf0g31CrBd4UemGm20sx/view?usp=sharingd/1g998HyVqXBSmsbqCJnj4HBQI0JgoFkarLavbWAODAMc/edit?usp=sharing',
    LinkedIn: 'https://www.linkedin.com/in/mursalin77/',
  };

  return (
    <>
      {/* Navbar */}
      <div
        className={`fixed top-0 left-0 w-full h-16 flex items-center justify-between px-4 md:px-12 font-bold z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-black bg-opacity-80 text-white'
            : 'bg-transparent text-white'
        }`}
      >
        {/* Logo */}
        <ScrollLink to={'About'} smooth={true} duration={2000} offset={-80}>
          <div>
            <Image
              alt='mursalin logo'
              src={'/mursalin-logo.png'}
              width={150}
              height={150}
            />
          </div>
        </ScrollLink>

        {/* Nav Items and Contact Button */}
        <div className='flex items-center space-x-4'>
          <div className='hidden md:flex space-x-6'>
            {navItems.map((item, index) =>
              externalLinks[item] ? (
                <NextLink
                  key={index}
                  href={externalLinks[item]}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='btn-magic hover:text-purple-400 cursor-pointer'
                >
                  {item}
                </NextLink>
              ) : (
                <ScrollLink
                  key={index}
                  to={item}
                  smooth={true}
                  duration={2000}
                  offset={-80}
                  className='btn-magic hover:text-purple-400 cursor-pointer'
                >
                  {item}
                </ScrollLink>
              )
            )}
          </div>

          <div className='hidden md:block'>
            <ScrollLink
              to={'Contact'}
              smooth={true}
              duration={3000}
              offset={-80}
            >
              <ButtonMini className='bg-black text-white border-purple-600 hover:border-blue-500 border-2 cursor-pointer'>
                Contact
              </ButtonMini>
            </ScrollLink>
          </div>

          <div className='md:hidden'>
            <button
              className='text-white hover:to-blue-500'
              onClick={openSidebar}
            >
              <FaHamburger size={24} />
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className='fixed top-0 left-0 h-full w-3/4 bg-gray-900 opacity-80 text-white z-50 shadow-lg transition-transform duration-300 ease-in-out -translate-x-full'
      >
        <button
          className='absolute top-4 right-4 text-white hover:text-gray-400'
          onClick={closeSidebar}
        >
          <FaTimes size={24} />
        </button>

        <div className='flex flex-col items-start p-6 space-y-6 mt-16'>
          {navItems.map((item, index) =>
            externalLinks[item] ? (
              <NextLink
                key={index}
                href={externalLinks[item]}
                target='_blank'
                rel='noopener noreferrer'
                className='text-lg font-semibold hover:text-purple-400 cursor-pointer'
                onClick={closeSidebar}
              >
                {item}
              </NextLink>
            ) : (
              <ScrollLink
                key={index}
                to={item}
                smooth={true}
                duration={2000}
                offset={-80}
                className='text-lg font-semibold hover:text-purple-400 cursor-pointer'
                onClick={closeSidebar}
              >
                {item}
              </ScrollLink>
            )
          )}

          <ScrollLink
            to={'Contact'}
            smooth={true}
            duration={3000}
            offset={-80}
            onClick={closeSidebar}
          >
            <ButtonMini className='bg-black text-white border-purple-600 hover:border-blue-500 border-2 cursor-pointer'>
              Contact
            </ButtonMini>
          </ScrollLink>
        </div>
      </div>

      {/* Background Overlay */}
      {isSidebarOpen.current && (
        <div
          className='fixed inset-0 bg-gray-500 z-40'
          onClick={closeSidebar}
        ></div>
      )}
    </>
  );
};

export default Navbar;
